'use client'

import { useEffect, useState } from 'react'
import {
  channelInitials,
  type LiveTvChannel,
} from '@/lib/live-tv-channels'

type Size = 'xs' | 'sm' | 'md' | 'lg'

const sizeClass: Record<Size, string> = {
  xs: 'h-7 w-7 text-[9px]',
  sm: 'h-9 w-9 text-[10px]',
  md: 'h-12 w-12 text-sm',
  lg: 'h-16 w-16 text-lg',
}

function resolveLogoSrc(channel: LiveTvChannel): string | null {
  if (channel.logoUrl) return channel.logoUrl
  if (channel.type === 'video') {
    return `https://i.ytimg.com/vi/${channel.id}/hqdefault.jpg`
  }
  return null
}

/** YouTube avatar (logoUrl) — unavatar kullanılmaz (429). */
export default function ChannelLogo({
  channel,
  size = 'md',
  className = '',
}: {
  channel: LiveTvChannel
  size?: Size
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const src = resolveLogoSrc(channel)

  useEffect(() => {
    setFailed(false)
  }, [channel.key, src])

  if (!src || failed) {
    return (
      <div
        className={`inline-flex shrink-0 items-center justify-center rounded-full font-black text-white shadow-sm ${sizeClass[size]} ${className}`}
        style={{ backgroundColor: channel.color }}
        aria-hidden
      >
        {channelInitials(channel.title)}
      </div>
    )
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      width={64}
      height={64}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-full object-cover ring-1 ring-black/10 dark:ring-white/10 ${sizeClass[size]} ${className}`}
    />
  )
}
